export const menuConstants = {
    REQUEST_MENU_ELEMENTS: 'REQUEST_MENU_ELEMENTS',
    REQUEST_SUBMENU_ELEMENTS: 'REQUEST_SUBMENU_ELEMENTS',
    DISPLAY_LOGOUT_BTN: 'DISPLAY_LOGOUT_BTN'
}

